module.exports = __webpack_public_path__ + "media/theme/tutorial__mobage--3--redeem-8358b736.png";